<template>
	<div class="performance-manage main-content-padding">
		<Panel :contentPaddingTop="$auth.hasPermi('teamManage:data-view') ? 24 : 0" :contentPaddingBottom="8" class="shopLibrary">
			<bread-crumb slot="header" style="background-color: #fff" />
			<div v-if="$auth.hasPermi('teamManage:data-view')">
				<search @change="refreshList"></search>
			</div>
		</Panel>
		<Panel :contentPaddingTop="$auth.hasPermi('teamManage:data-view') ? 24 : 0" :contentPaddingBottom="0">
			<overview :dataList="dataList"></overview>
		</Panel>
		<Panel v-if="$auth.hasPermi('teamManage:talent-business') || $auth.hasPermi('teamManage:Attract-investment')">
			<div class="box-wrap" style="padding: 0">
				<div class="box-wrap-top">
					<div class="left flex">
						<div class="title">员工业绩明细</div>
						<div class="tip ml-8">*数据更新时间为T+1</div>
					</div>
					<div class="box-wrap-top-right">
						<el-checkbox @change="onJobFlagFn" :true-label="1" :false-label="0" v-model="onJobFlag"></el-checkbox>
						<span class="ml-4 mr-4 total-text font-h6-regular">仅查看在职账号</span>
						<div class="line"></div>
						<table-column-custom ref="TableColumnCustom" :list_type="listType" :columns="headerColumns" @columnsChange="columnsChange" />
						<div class="line"></div>
						<div class="mr-12 total-text fz-12">
							共
							<span class="total-active">{{ total }}</span>
							位{{ isDr ? drName : zsName }}
						</div>
						<el-button type="primary" v-if="$auth.hasPermi('teamManage:export')" @click="exportExcel" :loading="loading">导出</el-button>
					</div>
				</div>
				<div>
					<el-tabs class="tab-list" v-model="staffName" @tab-click="staffHandleClick">
						<template v-for="(item, index) in tabList">
							<el-tab-pane :label="item.name" :name="item.value" v-if="item.showAuth" :key="index"></el-tab-pane>
						</template>
					</el-tabs>
					<div v-for="(item, index) in tabList" :key="index">
						<multi-table
							v-if="+staffName === index + 1"
							:defaultSort="defaultSort"
							ref="multiTable"
							class="base-table"
							:key="index"
							:page="pageInfo"
							:columns="filterColumns"
							:list="list"
							@getSortList="sortHandle"
							v-loading="tabLoading"
							@gePartnerList="getList"
							:total="total"
						>
							<empty :isSearch="true" style="position: relative; left: -50%" ref="empty" slot="empty"></empty>
						</multi-table>
					</div>
				</div>
			</div>
		</Panel>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getResultsInfo, getEmployeesList, employeesExport, getZsEmployeesList, exportZsEmployeesList } from '@/api/talentCRM';
import { startOfDay, endOfDay } from 'date-fns';
import search from './components/search.vue';
import overview from './components/overview/overview.vue';
import { PLATFORM_ALL, drRoleType, zsRoleType, pageConfig } from '@/utils/dataMap';
import TableColumnCustom from '@/components/business/TableColumnCustom/TableColumnCustom.vue';
import { calDate, disabledDate } from '@/utils/common';
import getColums from './components/column';
import { getFieldShow } from '@/api/common';
import empty from '@/views/common/empty/index.vue';
import { cloneDeep } from 'lodash';

export default {
	name: 'performanceManage',
	components: {
		search,
		overview,
		empty,
		TableColumnCustom,
	},
	data() {
		const setTime = (picker, value) => picker.$emit('pick', calDate(value));
		return {
			onJobFlag: 0,
			inofTime: calDate(7),
			pickerOptions: {
				shortcuts: [
					{ text: '昨天', onClick: picker => setTime(picker, 1) },
					{ text: '7天', onClick: picker => setTime(picker, 7) },
					{ text: '15天', onClick: picker => setTime(picker, 15) },
					{ text: '30天', onClick: picker => setTime(picker, 30) },
					{ text: '90天', onClick: picker => setTime(picker, 90) },
					{ text: '180天', onClick: picker => setTime(picker, 180) },
				],
				disabledDate,
			},
			dataList: [],
			list: [],
			total: 0,
			width: '',
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			staffName: '1',
			loading: false,
			timeType: 1,
			deptIds: [],
			search: {},
			filterColumns: [],
			headerColumns: [],
			sortParams: {
				order_field: 'totalAmount',
				order_sort: 'desc',
			},
			tabLoading: false,
			tabList: [
				{ name: drRoleType.name, showAuth: this.$auth.hasPermi('teamManage:talent-business'), value: '1' },
				{ name: zsRoleType.name, showAuth: this.$auth.hasPermi('teamManage:Attract-investment'), value: '2' },
			],
			authorityId: '',
			defaultSort: { prop: 'totalAmount', order: 'descending' },
		};
	},
	computed: {
		...mapGetters(['notSingleVersion', 'showDeptSelect', 'isAllDataView']),
		prices() {
			return num => `${num}`.split('.');
		},
		drName() {
			return drRoleType.name;
		},
		zsName() {
			return zsRoleType.name;
		},
		isDr() {
			return this.staffName === '1';
		},
		listType() {
			return this.isDr ? pageConfig.performanceManageListTelant : pageConfig.performanceManageListBd;
		},
	},
	created() {
		this.dataList = this.getDataConfig();
	},
	mounted() {
		this.staffName = this.$route.query?.staff_name || '1';
		this.platformId = this.notSingleVersion ? +PLATFORM_ALL.value : +this.defaultPlatform;
		if (this.$route.query?.from_time) {
			this.inofTime = [Number(this.$route.query?.from_time) * 1000, Number(this.$route.query?.to_time) * 1000];
			this.getResultsInfo();
		}
		this.getFieldShow();
	},
	methods: {
		getDataConfig() {
			const { platformId } = this.search;
			let dataConfig = [
				{ label: '支付金额', desc: '所选时间范围内，团长订单累计已支付的GMV', number: 0, showPrice: true, key: 'total_amount'},
				{ label: '结算金额', desc: '所选时间范围内，团长订单累计已结算的GMV', number: 0, showPrice: true, key: 'settle_amount'},
				{ label: '支付订单量', desc: '所选时间范围内，所有团长订单累计已支付的订单', number: 0, key: 'total_order'},
				{ label: '结算订单量', desc: '所选时间范围内，团长订单累计已结算的订单量', number: 0, key: 'settle_order'},
				{
					label: '预估服务费收入',
					desc: '所选时间范围内商家提供的预估服务费总计，包括已结算服务费、未结算服务费（未扣除技术服务费）',
					number: 0,
					showPrice: true,
					key: 'income_estimated_commission',
				},
				{
					label: '实际服务费收入',
					desc: '所选时间范围内商家提供的已结算服务费总计（已扣除技术服务费）',
					number: 0,
					showPrice: true,
					key: 'income_real_commission',
				},

				{
					label: '预估服务费支出',
					desc: '所选时间范围内给二级团长分成的预估服务费支出',
					number: 0,
					showPrice: true,
					key: 'disburse_estimated_commission',
					hide: this.$isSp(platformId),
				},
				{
					label: '实际服务费支出',
					desc: '所选时间范围内给二级团长分成的已结算服务费支出',
					number: 0,
					showPrice: true,
					key: 'disburse_real_commission',
					hide: this.$isSp(platformId),
				},

				{
					label: '预估到手服务费',
					desc: '预估服务费收入-预估服务费支出，预估可提取的金额',
					number: 0,
					showPrice: true,
					key: 'actually_estimated_commission',
					hide: this.$isSp(platformId),
				},
				{
					label: '实际到手服务费',
					desc: '真实可提取的金额。订单未到达结算状态时，实际到手服务费无数据',
					number: 0,
					showPrice: true,
					key: 'actually_real_commission',
					hide: this.$isSp(platformId),
				},

				{
					label: '预估技术服务费',
					desc: '为官方收取的技术服务费，若发生退货退款，该费用将不收取',
					number: 0,
					showPrice: true,
					key: 'service_estimated_commission',
					hide: this.$isSp(platformId),
				},
				{
					label: '实际技术服务费',
					desc: '为已结算状态订单，官方平台实际收取的技术服务费',
					number: 0,
					showPrice: true,
					key: 'service_real_commission',
					hide: this.$isSp(platformId),
				},

				{
					label: '预估商务提成',
					desc: '所选时间范围内团长所有支付订单的提成，已扣除官方平台技术服务费（若有）',
					number: 0,
					showPrice: true,
					key: 'estimated_commission',
				},
				{
					label: '结算商务提成',
					desc: '所选时间范围内已结算团长订单的提成，已扣除官方平台技术服务费（若有）',
					number: 0,
					showPrice: true,
					key: 'real_commission',
				},
				{
					label: '预估招商提成',
					desc: '所选时间范围内团长所有支付订单的招商预估提成汇总，已扣除官方平台技术服务费（若有）',
					number: 0,
					showPrice: true,
					key: 'bd_estimated_commission',
				},
				{
					label: '结算招商提成',
					desc: '所选时间范围内团长所有支付订单的招商结算提成汇总，已扣除官方平台技术服务费（若有）',
					number: 0,
					showPrice: true,
					key: 'bd_real_commission',
				},
				{ label: '出单达人数', desc: '所选时间段内有订单产生的达人数', number: 0, key: 'total_order_anchor' },
				{ label: '出单商品数', desc: '所选时间范围内有订单产生的商品数）', number: 0, key: 'total_order_product'},
			];
			return dataConfig.filter(v => !v.hide);
		},
		getList(obj) {
			const { page_size, page_index } = obj;
			this.pageInfo.page_size = page_size;
			this.pageInfo.page_index = page_index;
			this.getEmployeesList();
		},
		refreshList(obj) {
			this.search = obj;
			this.dataList = this.getDataConfig();
			this.getFieldShow();
			if (obj.onJobFlag) this.onJobFlag = +obj.onJobFlag;
			this.$nextTick(() => {
				this.getResultsInfo();
			});
		},
		async getResultsInfo() {
			const { deptIds, timeType: time_type, platformId: platform_id, userId, authority_id, inofTime } = this.search;
			const { code, data: d } = await getResultsInfo({
				from_time: Math.trunc(startOfDay(inofTime[0]) / 1000),
				to_time: Math.trunc(endOfDay(inofTime[1]) / 1000),
				platform_id,
				time_type,
				deptIds,
				userId,
				authority_id,
			});
			if (code !== 0) return;
			this.dataList.forEach(item => (item.number = d[item.key] || '0'));
			// arr.forEach((item, index) => (dataConfig[index].number = item));
			this.width = `${Math.trunc(200 / this.dataList.length)}%`;
			this.$auth.hasPermi('teamManage:talent-business') && this.getEmployeesList();
		},
		onJobFlagFn() {
			this.pageInfo = {
				page_index: 1,
				page_size: 10,
			};
			this.getEmployeesList();
		},
		async getEmployeesList() {
			try {
				this.tabLoading = true;
				const { deptIds, timeType: time_type, platformId: platform_id, userId, authority_id, inofTime } = this.search;
				const callback = this.isDr ? getEmployeesList : getZsEmployeesList;
				const { order_field, order_sort } = this.sortParams;
				const { code, data: { list = [], page = {} } = {} } = await callback({
					all_status: this.onJobFlag,
					from_time: Math.trunc(startOfDay(inofTime[0]) / 1000),
					to_time: Math.trunc(endOfDay(inofTime[1]) / 1000),
					page_index: this.pageInfo.page_index,
					page_size: this.pageInfo.page_size,
					platform_id,
					time_type,
					deptIds,
					userId,
					order_field,
					order_sort,
					authority_id,
				});
				if (code !== 0) return;
				this.list = list;
				this.total = page.item_total;
			} finally {
				this.tabLoading = false;
			}
		},
		async exportExcel() {
			try {
				this.loading = true;
				const { order_field, order_sort } = this.sortParams;
				const { deptIds, timeType: time_type, platformId: platform_id, userId, authority_id, inofTime } = this.search;
				const callback = this.isDr ? employeesExport : exportZsEmployeesList;
				const { download_url } = await callback({
					all_status: this.onJobFlag,
					from_time: Math.trunc(startOfDay(inofTime[0]) / 1000),
					to_time: Math.trunc(endOfDay(inofTime[1]) / 1000),
					platform_id,
					time_type,
					deptIds,
					userId,
					order_field,
					order_sort,
					authority_id,
				});
				this.loading = false;
				window.open(download_url, '_blank');
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
				this.loading = false;
			}
		},
		staffHandleClick() {
			this.pageInfo.page_index = 1;
			this.getFieldShow();
			this.getEmployeesList();
		},
		sortHandle(obj) {
			const { prop, order } = obj;
			const sortType = order === 'descending' ? 'desc' : 'asc';
			this.sortParams = {
				order_field: prop,
				order_sort: sortType,
			};
			this.getEmployeesList();
		},
		async getFieldShow() {
			const { listType: list_type } = this;
			let list = [];
			const filterColumns = getColums(this).filter(val => val);
			this.headerColumns = cloneDeep(filterColumns).filter(val => val.baseColums);
			try {
				const { data } = await getFieldShow({ list_type });
				list = data.fieldList || [];
			} finally {
				if (list.length) {
					this.headerColumns.forEach(item => {
						if (list.includes(item.key)) {
							item.show = true;
						} else {
							item.show = false;
						}
					});
				}
				this.filterColumns = this.headerColumns.filter(v => v.show);
				this.$nextTick(() => {
					this.$refs.TableColumnCustom?.init();
				});
			}
		},
		columnsChange(item) {
			this.filterColumns = item;
		},
	},
};
</script>

<style lang="less" scoped>
.performance-manage {
	height: 100%;

	.box-wrap {
		background-color: @color-gy1;
		padding: 24px;

		.box-wrap-top {
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: relative;
			padding-bottom: 8px;

			.left {
				line-height: 17px;

				.desc {
					font-weight: normal;
				}

				.title {
					color: #333;
					font-size: 16px;
					font-weight: bold;
				}

				.time {
					margin-left: 8px;
					font-size: 12px;
					color: #999;
				}
			}

			.box-wrap-top-right {
				display: flex;
				align-items: center;

				.line {
					width: 1px;
					height: 16px;
					background: @color-gy4;
					margin: 0px 12px;
				}
			}
		}

		.data-wrap {
			display: flex;
			flex-wrap: wrap;
			margin-top: 12px;
			font-family: DINAlternate-Bold, DINAlternate;

			.item {
				padding: 24px 0 24px 20px;
				box-sizing: border-box;
				color: #333;

				::v-deep .icon-a-help-circle-obangzhu-xian {
					color: #666;
					font-size: 12px;
				}

				.lh-32 {
					line-height: 32px;
				}

				.num {
					color: #333;
					font-size: 18px;
					font-weight: 700;
					font-family: HelveticaNeue-Medium, HelveticaNeue;
					line-height: 24px;
				}

				.price {
					color: #333;
					font-family: HelveticaNeue-Medium, HelveticaNeue;
					display: flex;
					align-items: baseline;
					line-height: 24px;

					&::before {
						content: '￥';
						font-size: 12px;
						font-family: HelveticaNeue;
					}
				}
			}
		}

		.person-info {
			display: flex;
			align-items: center;

			.el-image {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}

			.right {
				margin-left: 8px;
				font-size: 14px;
				color: #333;
				flex: 1;
				overflow: hidden;

				.mobile {
					color: #666;
				}
			}
		}
	}

	.total-text {
		color: @color-text-secondary;
	}

	.total-active {
		color: @color-gy9;
	}

	.tip {
		font-family: PingFang SC;
		font-size: 12px;
		line-height: 20px;
		color: @color-text-secondary;
	}

	.tab-list {
		/deep/ .el-tabs__item {
			font-weight: 400;
		}

		/deep/ .is-active {
			font-weight: 500;
		}
	}

	.base-table {
		/deep/ thead {
			font-size: 12px;
		}
	}
}

.content {
	text-align: center;
}

/deep/.el-range-separator,
/deep/.el-range__icon {
	line-height: 25px !important;
}

/deep/ .el-tabs__header {
	margin: 5px !important;
}
</style>
